import IndexTableRow from '../index-table/IndexTableRow'
import GroupedProjectsTableRowRenderer from './GroupedProjectsTableRowRenderer';

export default class GroupedProjectsTableRow extends IndexTableRow {
    loadRowRenderer() {
        this.rowRenderer = new GroupedProjectsTableRowRenderer(this.props, this);
    }
}